<template>
  <div class="pt-4 my-md-5 pt-md-5 border-top">
    <div class="row">
      <div class="col-12 col-md">
        <img
          class="mb-2"
          src="../../assets/static/icons/expar_logo_new2.svg"
          alt="logo"
          width="24"
          height="24"
        />
        <span class="logo-text">expar&#8482;</span>
        <small class="d-block mb-3 text-muted"
          >{{ $t('copyright') }} &copy; {{ new Date().getFullYear() }}</small
        >
      </div>
      <div class="col-6 col-md footerColumn left">
        <div>
          <h5>{{ $t('about') }}</h5>
          <ul class="list-unstyled text-small">
            <!-- <li><a class="text-muted" target="_blank" href="#">{{ $t('team') }}</a></li> -->
            <li>
              <a
                class="text-muted"
                target="_blank"
                href="https://linking-map.com/"
                >{{ $t('companyProfile') }}</a
              >
            </li>
          </ul>
        </div>
        <div class="hideDesktop">
          <h5>{{ $t('legal') }}</h5>
          <ul class="list-unstyled text-small">
            <li>
              <a
                v-if="env === 'production'"
                href="https://expar.si/politika-zasebnosti/"
                target="_blank"
                class="text-muted"
                >{{ $t('privacyPolicy') }}</a
              >
              <a
                v-else
                href="https://demo.expar.si/politika-zasebnosti/"
                target="_blank"
                class="text-muted"
                >{{ $t('privacyPolicy') }}</a
              >
            </li>
            <li>
              <a
                v-if="env === 'production'"
                href="https://expar.si/splosni-pogoji-b2b-a/"
                target="_blank"
                class="text-muted"
                >{{ $t('termsConditions') }}</a
              >
              <a
                v-else
                href="https://demo.expar.si/splosni-pogoji-poslovan/"
                target="_blank"
                class="text-muted"
                >{{ $t('termsConditions') }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="col-6 col-md footerColumn right">
        <h5>{{ $t('footerFeedback') }}</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a class="text-muted" href="mailto:info@linking-map.com">{{
              $t('sendFeedback')
            }}</a>
          </li>
          <!-- <li><a class="text-muted" href="#">{{ $t('rateService') }}</a></li> -->
        </ul>
      </div>
      <div class="col-6 col-md footerColumn left hideMobile">
        <h5>{{ $t('legal') }}</h5>
        <ul class="list-unstyled text-small">
          <li>
            <a
              v-if="env === 'production'"
              href="https://expar.si/politika-zasebnosti/"
              target="_blank"
              class="text-muted"
              >{{ $t('privacyPolicy') }}</a
            >
            <a
              v-else
              href="https://demo.expar.si/politika-zasebnosti/"
              target="_blank"
              class="text-muted"
              >{{ $t('privacyPolicy') }}</a
            >
          </li>
          <li>
            <a
              v-if="env === 'production'"
              href="https://expar.si/splosni-pogoji-b2b-a/"
              target="_blank"
              class="text-muted"
              >{{ $t('termsConditions') }}</a
            >
            <a
              v-else
              href="https://demo.expar.si/splosni-pogoji-poslovan/"
              target="_blank"
              class="text-muted"
              >{{ $t('termsConditions') }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      env: ''
    }
  },
  mounted() {
    this.env = process.env.NODE_ENV
  }
}
</script>

<style lang="css" scoped>
h5,
ul {
  text-align: left;
  padding: 5px;
}

.row span {
  font-family: 'Nasalization', Helvetica, Arial;
}

.logo-text {
  font-size: 1.1rem;
  font-weight: 500;
  margin-left: 8px;
}
@media (min-width: 561px) {
  .hideDesktop {
    display: none;
  }
}

@media (max-width: 560px) {
  h5 {
    padding: 0 0 0 5px;
  }

  .right {
    text-align: right;
    padding-right: ;
  }
  .left {
    text-align: left;
  }
  .row {
    margin-right: 0px;
    margin-left: 0px;
  }
  .logo-text {
    font-size: 1.1rem;
    font-weight: 500;
    margin-left: 4px;
  }
  .hideMobile {
    display: none;
  }
}
</style>
